<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add Channel"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addForm" :model="addForm" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.name"
                                placeholder="Name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Channel Code"
                            prop="channel_code"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.channel_code"
                                placeholder="Channel Code"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Delivery"
                            prop="delivery"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.delivery"
                                placeholder="Delivery"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24">
                        <el-form-item label="Status" size="small" prop="status">
                            <el-radio-group v-model="addForm.status">
                                <el-radio :label="1">Active</el-radio>
                                <el-radio :label="2">Disable</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col> -->
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            addForm: {
                name: "",
                channel_code: "",
                delivery: "",
                status: 1,
            },
            roleList: [],
        };
    },
    methods: {
        save() {
            this.loading = true;
            cmofferApi
                .channel(
                    {
                        ...this.addForm,
                    },
                    "post",
                )
                .then((res) => {
                    this.loading = false;
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.closeDialog();
                    this.$parent[this.funcName]();
                });
        },
        closeDialog() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        async initialize() {
            this.channel();
        },
    },
    props: {
        addVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        addVisible() {
            if (this.addVisible) {
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.add {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
